import { render, staticRenderFns } from "./NoTrendIcon.vue?vue&type=template&id=503c44ff&scoped=true&"
import script from "./NoTrendIcon.vue?vue&type=script&lang=js&"
export * from "./NoTrendIcon.vue?vue&type=script&lang=js&"
import style0 from "./NoTrendIcon.vue?vue&type=style&index=0&id=503c44ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503c44ff",
  null
  
)

export default component.exports